<template>
  <b-row>
    <b-col cols="1">
      <b-col cols="1">
        <div style="height: 24px;"></div>
        <div class="cPhoto p-1">
          <b-img-lazy
            id="profilePhotoUploadPreview"
            v-if="$route.params.id"
            class="cImg"
            :src="`/api/v1/people/${$route.params.id}/photo/profile?type=preview`"
          />
        </div>
      </b-col>
    </b-col>
    <b-col cols="4">
      <b>Přidat do profilovou fotku:</b>
      <b-form-file
        id="profilePhotoUpload"
        class="uploadForm"
        :style="`background-image: url('${profilePhotoBackground}');`"
        v-model="singleFile"
        :state="Boolean(singleFile)"
        placeholder
        drop-placeholder
      />
    </b-col>
    <b-col cols="5">
      <b>Přidat fotky do galerie:</b>
      <b-form-file
        id="photosUpload"
        class="uploadForm"
        :style="`background-image: url('${photosBackground}');`"
        v-model="files"
        :state="Boolean(files)"
        multiple
        placeholder
        drop-placeholder
      />
    </b-col>

    <b-col cols="2">
      <b-row>
        <b-button @click="uploadFiles" variant="success" class="mt-4 btn-block mx-4">Nahrát fotky</b-button>
      </b-row>
      <b-row>
        <b-button variant="success" @click="$router.go(-1)" class="mt-4 btn-block mx-4">Zpět</b-button>
      </b-row>
      <b-row>
        <b-button
          variant="danger"
          @click="cancelSelection  "
          class="mt-4 btn-block mx-4"
        >Vymazat formulář</b-button>
      </b-row>
    </b-col>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="uploadWait"
      :title="uploadWaitTitle"
    >
      <div class="text-center">
        <b-spinner variant="success" label="Spinning"></b-spinner>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    profilePhotoBackground: require('../assets/profile-photo-upload.svg'),
    photosBackground: require('../assets/photo-upload.svg'),
    singleFile: null,
    files: [],
    index: null,
    uploadWaitTitle: null,
    uploadState: {
      singleFile: false,
      multiFile: false,
      uploadStep: 0
    }
  }),
  mounted () {

  },
  components: {},
  watch: {
    'uploadState.uploadStep': function (value) {
      if (this.uploadState.singleFile === true) {
        this.uploadWaitTitle = 'Nahrávám profilovou fotku'
      }
      if (this.uploadState.multiFile === true) {
        this.uploadWaitTitle = 'Nahrávám fotky do galerie'
      }
      // Ak sa cokolvek uploaduje tak zobraz wait state Modal
      if (this.uploadState.singleFile || this.uploadState.multiFile) {
        this.$bvModal.show('uploadWait')
      } else {
        this.$bvModal.hide('uploadWait')
      }
    }
  },
  methods: {
    cancelSelection () {
      this.singleFile = null
      this.files = []
    },
    uploadFiles: function () {
      // Upload profilove fotky
      if (this.singleFile) {
        this.uploadState.singleFile = true // prebieha upload singleFile
        this.uploadState.uploadStep++ // Info pre Watcher zmena stavu
        const formData = new FormData()
        formData.append('upload', this.singleFile)
        axios
          .post(`/api/v1/people/${this.$route.params.id}/photo?type=profile`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.singleFile = null
            this.uploadState.singleFile = false // dokoncen upload singleFile
            this.uploadState.uploadStep++ // Info pre Watcher zmena stavu
            this.$bvToast.toast(`Uloženo`, {
              title: 'Profilova fotka',
              variant: 'success',
              autoHideDelay: 1000
            })

            const flag = document.getElementById(`profilePhotoInputPreview`)
            console.log('flag', flag)
            let src = flag.src + '?' + new Date().getTime()
            flag.src = src
            const flag2 = document.getElementById(`profilePhotoUploadPreview`)
            let src2 = flag2.src + '?' + new Date().getTime()
            flag2.src = src2
            // this.$router.go(0);
          })
          .catch(response => {
            this.uploadState.singleFile = false // dokoncen upload singleFile
            this.uploadState.uploadStep = 0 // Info pre Watcher zmena stavu
            this.$bvModal.hide('uploadWait')
            alert('upload error: ', response)
          })
      }
      // Upload ostatnich fotek
      if (this.files.length !== 0) {
        let requests = this.files.reduce((promiseChain, item) => {
          return promiseChain.then(() => new Promise((resolve) => {
            const formData = new FormData()
            formData.append('upload', item)
            this.uploadState.multiFile = true // prebieha upload multiFile
            axios.post(`/api/v1/people/${this.$route.params.id}/photo`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
              .then(response => {
                this.uploadState.uploadStep++ // Ak sa pokracuje na dalsi upload tak nastav true
                console.log('Upload souboru dokoncen')
                resolve()
              })
              .catch(response => {
                this.uploadState.multiFile = false // dokoncen upload singleFile
                this.uploadState.uploadStep = 0 // Info pre Watcher zmena stavu
                this.$bvModal.hide('uploadWait')
                alert('upload error: ', response)
              })
          }))
        }, Promise.resolve())

        requests.then(() => {
          this.files = []
          axios
            .get(`/api/v1/people/${this.$route.params.id}/photo`)
            .then(response => {
              let peopleID = this.$route.params.id
              response.data.forEach(function (photoFolder) {
                let photos = []
                photoFolder.photos.forEach((photo) => {
                  photos.push(`/api/v1/people/${peopleID}/photo/${photoFolder.name}/${photo}`)
                })
                photoFolder.photos = photos
              })
              this.$store.commit('galleryPhotos', response.data)
              this.uploadState.multiFile = false // dokoncen upload multiFile
              this.uploadState.uploadStep++ // Info pre Watcher zmena stavu
              this.$bvToast.toast(`Uloženo`, {
                title: 'Fotky galerie',
                variant: 'success',
                autoHideDelay: 1000
              })
            })
        })
      }
    }
  }
})
</script>

<style>
.uploadForm {
  height: 200px;
  width: 100%;
  border: 1px solid rgba(133, 116, 116, 0.4);
  border-radius: 5px;
  background-color: white;
  background-repeat: no-repeat;
  background-position: center;
  border-style: solid;
}

.cPhoto {
  display: flex;
  flex: 1;
  height: 198px;
  min-width: 7vw;
  background-image: radial-gradient(
    rgb(220, 220, 220) 30%,
    rgb(255, 255, 255) 75%
  );
}
</style>
